import React from 'react';
import { Navbar } from 'react-bootstrap';

const Reviews = () => {
    return (
        <Navbar />
    );
};

export default Reviews;